import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Card, Icon, Title, TopSection } from "./Card.Style";
import { buttonCSS } from "../general.style";
import { postAnalytics } from "../../../../../PatientComponents/analytics";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";

const consentForm = "/CONSENT-FORM.svg";
const pdfUrl = "/Colonoscopy_Consent_Form_Readable.pdf";

export default function Consent() {
  const { t } = useTranslation();
  const { event } = usePatientFacing();
  const caseId = event?.Case?.id;

  const handleConsentClick = () =>
    postAnalytics({ userId: caseId, type: "instructions-consent-clicked" });

  return (
    <Card>
      <TopSection>
        <Title>
          {t("Consent-Title")}
        </Title>
        <Icon src={consentForm} alt="consentForm" />
      </TopSection>

      <Text>
        {t("Consent-Paragraph")}
      </Text>

      <ConsentLink
        href={pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleConsentClick}
      >
        {t("Consent-Download")}
      </ConsentLink>
    </Card>
  );
}

const Text = styled.p`
  margin: 0;
  margin-block-end: 2.188rem;
  font-size: 1.188rem;
`;

const ConsentLink = styled.a`
  ${buttonCSS}
  display: block;
  text-align: center;
  text-decoration: none;
  margin-block-start: 0;
`;
